import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import StudentPortalAuthService from '../services/StudentPortalAuthService';

const StudentPortalContext = createContext();

export function StudentPortalProvider({ children }) {
  const authService = useMemo(() => new StudentPortalAuthService(), []);
  const [student, setStudent] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const session = authService.getSession();
    if (session?.id) {
      const record = authService.getStudentById(session.id);
      setStudent(record || null);
    }
    setReady(true);
  }, [authService]);

  const signIn = async (reference, dob, password) => {
    const result = await authService.signIn(reference, dob, password);
    if (result.student) {
      setStudent(result.student);
    }
    return result;
  };

  const signOut = () => {
    authService.signOut();
    setStudent(null);
  };

  return (
    <StudentPortalContext.Provider value={{ student, ready, signIn, signOut }}>
      {children}
    </StudentPortalContext.Provider>
  );
}

export function useStudentPortal() {
  const context = useContext(StudentPortalContext);
  return context || { student: null, ready: true, signIn: async () => ({}), signOut: () => {} };
}
